import type { SmartOLTLiveTopologyOnu, SmartOLTStatusKind } from "../../../services/smartolt.service.ts"

export type TopologyNodeState = "online" | "fault" | "unknown"

export const TOPOLOGY_COLORS: Record<TopologyNodeState, string> = {
  online: "#22c55e",
  fault: "#f97316",
  unknown: "#94a3b8",
}

export function nodeState(kind: SmartOLTStatusKind | string | null | undefined): TopologyNodeState {
  if (kind === "online") return "online"
  if (kind === "los" || kind === "power" || kind === "offline") return "fault"
  return "unknown"
}

export function formatSignal(value?: number | null) {
  if (value == null || Number.isNaN(value)) return "—"
  return `${value} dBm`
}

export function filterOnus(rows: SmartOLTLiveTopologyOnu[], search: string) {
  const q = search.trim().toLowerCase()
  if (!q) return rows
  return rows.filter((row) =>
    [row.name, row.onu_external_id, row.zone_name, row.board, row.port]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(q),
  )
}

export function formatUpdated(value?: string | null) {
  if (!value) return "—"
  const dt = new Date(value)
  if (Number.isNaN(dt.getTime())) return "—"
  return dt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })
}
